module.exports = __webpack_public_path__ + "img/Unidad5-3.5f1fdc60.png";